import _ from 'underscore';
import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { SidePanelContext } from './side-panel-context';
import type { PanelContainerInfo } from './side-panel-context';

export interface SidePanelContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
  Pick<PanelContainerInfo, 'showPanelContainer'> {}

export const SidePanelContainer = (props: SidePanelContainerProps) => {
  const { setPanelContainerInfo } = useContext(SidePanelContext);

  const {
    showPanelContainer,
    id: idInProps,
    ...divProps
  } = props;

  const id = useMemo(() => idInProps || _.uniqueId('side-panel-container-'), [idInProps]);

  useEffect(() => {
    setPanelContainerInfo({ id, showPanelContainer });

    return () => setPanelContainerInfo({});
  }, [showPanelContainer, setPanelContainerInfo, id]);

  return (
    <div id={id} {...divProps} />
  );
};

SidePanelContainer.propTypes = {
  showPanelContainer: PropTypes.func,
  id: PropTypes.string,
};

SidePanelContainer.defaultProps = {
  showPanelContainer: _.noop,
  id: null,
};
